import { Injectable } from "@angular/core";
import { Observable, from } from "rxjs";
import { Browser } from "@capacitor/browser";

@Injectable({
  providedIn: "root",
})
export class BrowserCapacitor {
  execute(url: string): Observable<boolean> {
    return from(
      new Promise<boolean>(async (resolve, reject) => {
        await Browser.open({
          url: url,
        });
        Browser.addListener("browserFinished", () => {
          resolve(true);
        });
      })
    );
  }
}
